export const HEAT = ['#f9ed13', '#f8c51b', '#f69f1c', '#f37f20', '#ee641f', '#e85124'];
export const NO_DATA = '#dcecff';
export const HOVER = '#ff2c84';
export const OWN_CUSTOMER = '#16a36a';

const money = new Intl.NumberFormat('pl-PL', {
  style: 'currency',
  currency: 'PLN',
  maximumFractionDigits: 0,
});

const integer = new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 0 });

export function formatMoney(value) {
  return money.format(Number(value || 0));
}

export function formatInteger(value) {
  return integer.format(Number(value || 0));
}

export function formatArr(item) {
  if (!item) return '—';
  const value = Number(item.potential_arr || 0);
  const complete = Boolean(item.arr_complete);
  const valued = Number(item.valued_targets_count || 0);
  const targets = Number(item.targets_count || 0);

  if (!complete && valued === 0 && targets > 0) return 'ARR do uzupełnienia';
  return `${complete ? '' : '≥ '}${formatMoney(value)}`;
}

export function metricValue(item, metric) {
  if (!item) return null;
  if (item.is_own_customer) return null;
  if (metric === 'arr') return Number(item.potential_arr || 0);
  if (metric === 'mrr') return Number(item.potential_mrr ?? (Number(item.potential_arr || 0) / 12));
  if (metric === 'children') return Number(item.children_total ?? item.children_count ?? 0);
  if (metric === 'score') return item.score === null || item.score === undefined ? null : Number(item.score);
  return item.effective_score === null || item.effective_score === undefined ? null : Number(item.effective_score);
}

export function metricText(item, metric) {
  if (item?.is_own_customer) return 'Nasza placówka';
  if (metric === 'arr') return formatArr(item);
  if (metric === 'mrr') {
    const value = metricValue(item, metric);
    const complete = item?.arr_complete !== false;
    return `${complete ? '' : '≥ '}${formatMoney(value || 0)}`;
  }
  if (metric === 'children') {
    const value = metricValue(item, metric);
    const complete = item?.children_complete !== false;
    return `${complete ? '' : '≥ '}${formatInteger(value || 0)} dzieci`;
  }
  const value = metricValue(item, metric);
  return value === null ? 'brak wyniku' : `${Math.round(value)}/100`;
}

export function metricTitle(metric) {
  if (metric === 'arr') return 'Potencjalny ARR';
  if (metric === 'mrr') return 'Potencjalny MRR';
  if (metric === 'children') return 'Liczba dzieci';
  if (metric === 'score') return 'Scoring';
  return 'Efektywny scoring';
}

export function scoreColor(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return NO_DATA;
  const v = Math.max(0, Math.min(100, Number(value)));
  const index = Math.min(HEAT.length - 1, Math.floor(v / (100 / HEAT.length)));
  return HEAT[index];
}

export function arrColor(value, visibleValues) {
  const v = Number(value || 0);
  if (!(v > 0)) return NO_DATA;

  const positives = visibleValues.map(Number).filter((x) => x > 0);
  if (!positives.length) return NO_DATA;

  const min = Math.min(...positives);
  const max = Math.max(...positives);
  if (max <= min) return HEAT[HEAT.length - 2];

  const logMin = Math.log1p(min);
  const logMax = Math.log1p(max);
  const ratio = (Math.log1p(v) - logMin) / (logMax - logMin);
  const index = Math.max(0, Math.min(HEAT.length - 1, Math.floor(ratio * HEAT.length)));
  return HEAT[index];
}

export function itemColor(item, metric, visibleItems) {
  if (item?.is_own_customer) return OWN_CUSTOMER;
  if (metric === 'arr' || metric === 'mrr' || metric === 'children') {
    return arrColor(metricValue(item, metric), visibleItems.map((entry) => metricValue(entry, metric) || 0));
  }
  return scoreColor(metricValue(item, metric));
}

export function sortByMetric(items, metric) {
  return [...items].sort((a, b) => {
    const av = metricValue(a, metric);
    const bv = metricValue(b, metric);
    if (av === null && bv === null) return String(a.name).localeCompare(String(b.name), 'pl');
    if (av === null) return 1;
    if (bv === null) return -1;
    return bv - av || String(a.name).localeCompare(String(b.name), 'pl');
  });
}
